import { IconShield } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';

// The user-token lane's constraint text (#21) — always visible on the connect
// form. developerz.ai acts on GitHub AS the user (no bot-disclosure footer), so
// these three points are a hard requirement of the task, not decoration. Kept
// in its own presenter: legal copy is one reason to change.
export function GithubTokenTerms(): JSX.Element {
  return (
    <div class="alert alert--icon github-token__terms" role="note">
      <IconShield />
      <p class="alert__title">{t('github_token.terms_title')}</p>
      <ul class="github-token__terms-list">
        <li>{t('github_token.terms_acts_as_you')}</li>
        <li>{t('github_token.terms_responsibility')}</li>
        <li>{t('github_token.terms_fine_grained')}</li>
      </ul>
    </div>
  );
}
